export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "标签已成功添加到您的交易帐户。",
        ok: "确认",
        add_account_label: "添加帐户标签",
        trading_account: "交易帐户",
        select_trading_id: "选择交易 ID",
        label: "标签",
        alpha_numeric_characters : "为您的帐户分配标签：（字母数字最多 15 个字符）",
        apply: "申请",
        cancel: "取消",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "我们已收到您更改交易 ID 杠杆的请求",
        from :"来自",
        to :"发送至",
        confirm_mail_id:"如需确认，请点击发送至您注册电子邮件 ID 的确认链接。",
        leverage_successfully_change:"更改杠杆请求已成功处理",
        change_account_leverage:"更改账户杠杆",
        select_trading_account :"选择交易帐户",
        existing_leverage :"现有杠杆",
        new_leverage :"新杠杆",
        select_new_leverage :"选择新杠杆",
        change_leverage:"更改杠杆",
        account_leverage_reduced :"如果账户杠杆从当前杠杆降低，它将增加您未平仓交易的使用保证金（如果有的话）。",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"在创建多个真实账户之前必须先完成 KYC。",
        submit_proof_address:"请使用支持票提交地址证明",
        click_here:"点击此处",
        email_to: "或发送电子邮件至",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "接受以下地址证明：",
        utility_bill: "水电费账单",
        bank_statement: "银行对帐单",
        government_issued:"政府签发的税务文件",
        note:"备注",
        proof_of_address:"地址证明必须不超过 4 个月",
        account :"账户",
        select_platform:"选择平台",
        select_account_type:"选择账户类型",
        connect_your_account:"您想将账户连接到 ZuluTrade 吗?",
        select_leverage:"选择杠杆",
        select_account_base_currency:"选择账户基础货币",
        select_currency:"选择货币",
        Password:"密码",
        minimum_password_length5:"密码最小长度为 5 个字符，且必须至少包含 1 个小写字母、1 个大写字母和 1 个特殊字符。",
        minimum_password_length8:"密码最小长度为 8 个字符，且必须至少包含 1 个小写字母、1 个大写字母和 1 个特殊字符。",
        spcl_characters:"字符数",
        lowercase_letter:"小写字母",
        capital_letter:"大写字母",
        number: "数字",
        special_character:"特殊字符",
        confirm_password :"确认密码",
        trade_With_virtual_funds:"用虚拟资金交易",
        test_strategies:"免费测试策略",
        risk_free_trading:"无风险交易",
        live_market_feed: "实时市场动态",
        liquidity_from_top :"来自顶级 LPs 的流动性",
        effective_trading:"有效的交易工具",
        instant_execution:"立即执行",
        low_commissions:"低佣金和价差",
        create_new:"新创建",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "启用双因素身份验证",
        click_to_enable: "单击以启用",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"我们已收到您转账的请求",
        from_trading_account:"从交易账户",
        to_confirm:"如需确认，请点击发送至您注册电子邮件 ID 的确认链接。",
        internal_transfer_request:"您的从账户中进行内部转账的请求",
        for_amount:"金额",
        to_account:"到账户",
        was_succesfull :"已成功完成",
        internal_transfer: "内部转账",
        transfer_From: "转账来自",
        transfer_to:"转账至",
        balance: "余额",
        enter_amount: "输入金额",
        USE_MAX:"使用最大",
        proceed:"已操作",
        Internal_Transfer_ZIP:"内部转账不适用于 ZTP 账户",
        In_case_of_internal_transfer:"注:不同基准货币账户之间的内部转账，转账金额将按当时的市场价格计算。",
        
        /*=== manage-account.vue ====*/
        attention :"注意 - 您即将请求删除交易 ID",
        note_after_requesting:"注: - 请求后，您的账户将从记录中删除，您将无法恢复它。",
        after_clicking:"点击确认按钮后，您将收到发送至您注册电子邮件 ID 的确认链接以删除您的交易账户",
        currency: "货币",
        Account_Type: "帐户类型",
        Account_Label: "帐户标签",
        Bonus: "奖金",
        Leverage: "杠杆",
        Equity: "净值",
        Create_Demo_Account: "创建模拟账户",
        Create_Live_Account :"创建真实账户",
        internal_transfer_CAP:"内部转账",
        web_trading:"网页交易",
        add_account_label_CAP:"添加帐户标签",
        change_laverage:"更改杠杆",
        delete_account:"删除账户",
        reset_trading_password:"重置交易密码",
        
        verifying_your_request: "正在验证您的请求...",
        success: "成功",
        error: "错误",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"我们收到您请求重置投资人密码。如需确认，请点击发送至您注册电子邮件 ID 的确认链接。",
        change_investor_password:"更改投资人密码已成功。",
        reset_investor_password:"重置投资人密码",
        investor_password:"投资人密码",
        master_password:"主密码",
        trading_iD: "交易 ID",
        enter_new_password:"输入新密码",
        confirm_new_password :"确认新密码",
        password_must_contain:"您的密码必须包含最少 6 个字符、最多 10 个字符、1 个数字、1 个大写字母和 1 个特殊字符(!@$%*)",
        change_Password:"更改密码",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"重置主密码",
        click_reset:"点击此处重置",
        password_caption:"投资人密码是只读式密码，它不能让用户交易。如果您用主密码登入，您可以在账户中获得完全的访问权限和交易权。",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "企业",
        account_type: "帐户类型",
        select_account_type: "选择帐户类型",
        individual: "个人",
        name_of_company: "公司名称",
        country_of_company: "公司所在国家",
        select_company_country: "选择公司国家",
        registration: "注册",
        email_company: "公司电子邮件",
        Password: "密码",
        min_password_length8: "密码最小长度为 8 个字符，且必须至少包含 1 个小写字母、1 个大写字母、1 个数字和 1 个特殊字符。",
        spcl_characters: "字符数",
        lowercase_letter: "小写字母",
        capital_letter: "大写字母",
        number: "数字",
        special_character: "特殊字符",
        confirm_password: "确认密码",
        Phone_Number: "电话号码",
        have_read: "我已阅读、理解并接受",
        terms_conditions: "条款和条件",
        accept_terms_conditions: "请接受条款和条件",
        given_your_residency: "鉴于您的居住地，您将加入由胡志明市监管的 Triple A Experts Investment Services (GR)。您可以在我们的网站上查看有效的保护以及条款和条件。通过点击 ",
        continue: "继续",
        triple_investment_services: "您同意在 Triple A Experts Investment Services (GR) 开设帐户。",
        register: "注册",
        already_have_account: "已经有帐户？",
        login: "登录",
        /*=== forgot-password.vue ====*/
        confirmation_link: "确认链接已发送至您注册的电子邮件 ID。请点击链接重置您的登录密码。",
        ok: "确认",
        this_email_address: "该电子邮件地址未在我们这里注册。",
        click_here: "点击此处",
        create_account_now: "立即创建帐户",
        forgot_password: "忘记密码",
        email_address: "电子邮件地址",
        submit: "提交",
        dont_have_account: "没有帐户？",
        create_account_now_CAP: "立即创建帐户！",
        /*=== login.vue ====*/
        client_login: "客户登录",
        remember_me: "记住账号",
        two_step_verification: "两步验证",
        google_authenticator: "请输入 Google 身份验证器应用程序中显示的一次性密码。",
        google_auth_code: "谷歌授权码",
        /*=== register.vue ====*/
        sent_an_OTP: "我们已将一次性密码发送至",
        complete_your_registration: "请输入它以验证并完成您的注册。",
        otp: "一次性密码",
        Register_heading: "注册",
        first_name: "名",
        last_name: "姓",
        email: "电子邮件",
        country: "国家",
        select_residence_country: "选择居住国家",
        privacy_policy: "隐私政策",
        accept_privacy_policy: "请接受隐私政策",
        experts_investment_services: "鉴于您的居住地，您将加入由胡志明市监管的 Triple A Experts Investment Services (GR)。您可以在我们的网站上查看有效的保护以及条款和条件。通过点击 ",
        opening_your_account: "您同意在 Triple A Experts Investment Services (GR) 开设帐户。",
        /*=== reset-password.vue ====*/
        login_password_change: "您的登录密码已成功更改。",
        reset_password: "重置密码",
        reset: "重置",
    },
    //H
    copy_trading: {
        copy_trading: "复制交易",
        copy_trading_header: "通过自动复制策略经理的交易来赚取利润",
        leading_traders: "自动跟单领先交易者",
        diversified_trading: "多元化的交易组合",
        monitor_profit: "监控与利润",
        copy_traders: "如何复制交易？",
        one: "1.",
        one_header: "开设真实帐户并存款。",
        two: "2.",
        two_header: "选择策略经理。",
        three: "3.",
        three_header: "同意条款和条件。",
        four: "4.",
        four_header: "向我们提供您的协议。",
        five: "5.",
        five_header: "通过复制交易赚取利润。",
        order_processing: "快速订单处理",
        end_result: "控制最终结果",
        trading_skills: "提升您的交易技巧",
        start: "开始"
    },
    downloads: {
        mt_four_desktop: "桌面版 MT4",
        mt_four_android: "安卓版 MT4",
        mt_four_ios: "苹果版 MT4",
        mt_four_web_trader: "MT4 网页交易端",
        mt_five_desktop: "桌面版 MT5",
        mt_five_android: "安卓版 MT5",
        mt_five_ios: "苹果版 MT5",
        mt_five_web_trader: "MT5 网页交易端",
        act_trader_desktop: "Act Trader 桌面版",
        act_trader_android: "Act Trader 安卓版",
        act_trader_ios: "Act Trader 苹果版",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "您确定要使用 VPS",
        package: "包？",
        yes: "是",
        no: "否",
        downloads: "下载",
        copy_trading: "复制交易",
        vps: "VPS"
    },
    vps: {
        vps_plans: "VPS 计划",
        bronze: "青铜",
        monthly_subscription_twenty_five: "每月订阅 25 美元",
        free_deposit_five_thousand: "存款满 5,000 美元或以上即可免费获得",
        compatible_mt_four_five_act: "兼容 MT4、MT5 和 Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "免费 25 GB 磁盘空间 | 1300 MB 内存 | 1 个虚拟 CPU",
        windows_linux_support: "Windows 8/10/12，支持 Linux",
        avail_now: "立即使用",
        silver: "白银",
        monthly_subscription_fourty_five: "每月订阅 45 美元",
        free_on_deposit_ten_thousand: "存款满 10,000 美元或以上即可免费获得",
        free_fifty_gb_disk_space_ram_vcpu: "免费 50 GB 磁盘空间 | 2700 MB 内存 | 2 个虚拟 CPU",
        gold: "黄金",
        monthly_subscription_eighty: "每月订阅 80 美元",
        free_on_deposit_fifteen_thousand: "存款满 15,000 美元或以上即可免费获得",
        free_seventy_five_gb_disk_space_ram_vcpu: "免费 75 GB 磁盘空间 | 5120 MB 内存 | 3 个虚拟 CPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "取消提款请求",
        cancel_your_withdrawal_request: "您确定要取消提款请求吗",
        process_request: "处理请求",
        open_tickets: "开单",
        back: "返回",
        ticket_number: "单号：",
        created: "创建：",
        reason: "原因:"
    },
    bonus: {
        request_to_avail_bonus: "您为交易 ID",
        trading_id: "使用奖金的请求",
        click_confirmation_link: "已经收到。如需确认，请点击发送至您注册电子邮件地址的确认链接。",
        request_to_remove_bonus: "您要求消除奖金",
        bonus_amount: "您的奖金金额为",
        successfully_removed_account: "已成功从帐户 ID 中消除",
        ok: "确认",
        request_to_add_bonus: "您添加奖金的请求",
        successfully: "已成功。",
        bonus: "奖金",
        select_trading_id: "选择交易 ID",
        use_max: "使用最大",
        account_type: "帐户类型",
        equity: "净值",
        leverage: "杠杆",
        currency: "货币",
        current_bonus: "当前奖金",
        allowed_bonus: "允许的奖金",
        remove: "消除",
        account_first: "请先选择帐户",
        bonus_amount_base_currency: "备注：输入基础货币的奖金金额。",
        point_one: "1.我们的 100% 奖金优惠适用于最低存款 100 美元且帐户杠杆高达 1:200 的所有客户。每个客户允许的最高奖金为 40,000 美元。",
        point_two: "2.通过我们的奖金进行交易所赚取的利润将全部归您所有。如果您提取利润，奖金将不会被扣除。",
        point_three: "3.奖金增加您帐户中的可用保证金。但是，您的损失不能从奖金中扣除。如果您交易的总损失超过您的自有资金，系统将自动平仓您交易帐户中的头寸，而无需任何事先通知。",
        point_four: "4.如果您提取自有资金，则相应金额的奖金将从您的帐户中扣除。",
        read_understood_accepted: "我已阅读、理解并接受",
        aaafx_bonus_policy: "AAAFx 奖金政策。",
        accept_aaafx_bonus_policy: "请接受 AAAFx 奖金政策",
        proceed: "继续",
        no_bonus_available_account: "此账户没有奖金可用"
    },
    refer_earn: {
        bonus: "奖金",
        refer_earn: "推荐并赚取",
        refer_friend: "推荐朋友",
        earn_dollar_twenty_five: "每推荐一个朋友",
        per_friend: "赚取 25 美元",
        why_refer_someone_to_us: "您推荐他人给我们的理由？",
        refer_someone_point_one: "1.您和您的朋友将获得推荐奖金。",
        refer_someone_point_two: "2.简单快速的程序",
        refer_someone_point_three: "3.您双方都受益于我们有利的交易条件。",
        refer_someone_point_four: "4.推荐的收入是无限的。",
        what_need_to_do: "您需要做的是：",
        what_need_to_do_point_one: "1.将您的推荐链接分享给您的同事。",
        what_need_to_do_point_two: "2.您的推荐人使用您分享的链接注册并开始交易。",
        what_need_to_do_point_three: "3.一旦您的推荐人符合资格，你们每人都会获得 25 美元。",
        referral_list: "您的推荐人列表"
    },
    referral_list: {
        referrals_list: "推荐名单",
        list_of_referrals: "用于跟踪您的收入的推荐列表。",
        s_no: "S 编号",
        name: "姓名",
        email_id: "电子邮件 ID",
        account_stage: "账户阶段",
        deposits: "存款",
        volume_required: "所需交易量",
        traded_volume: "交易量",
        qualified: "合格的",
        no_data: "没有数据",
        payment_of_referral_bonus: "推荐奖金的支付应在推荐合格当周的下一周内完成。",
        referral_bonus_paid_in_aaafx_wallet: "推荐奖金将存入 AAAFx 美元钱包，随后推荐人和被推荐人可以提取或转入其交易账户。",
        read_all_terms_conditions: "阅读所有条款和条件",
        here: "此处",
        contact_us: "有疑问？通过 24/5 实时聊天联系我们或写信给我们",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "定义",
        meaning_of_all_above_columns: "以下是上面所有列的含义，供您参考：",
        name_of_your_referral: "- 您的推荐人姓名。",
        meaning_of_various_stages: "- 请参阅下面各个阶段的含义。",
        registered: "1.已注册：",
        registered_link: "您推荐的人已使用您分享的链接注册。",
        funded: "2.已注资：",
        referral_deposited: "您推荐的人已存入资金。",
        third_point_qualified: "3.合格的：",
        referral_has_deposited: "您推荐的人已存入资金并达到要求的交易量。你们俩现在都有资格获得奖励。",
        deposits_made_by_referral: "- 通过您推荐的人进行存款。",
        volume_requirement: "交易量要求",
        volume_required_for_reward: "- 您推荐的人有资格获得奖励所需的交易量。",
        volume_your_referral_traded: "- 您推荐的人的实际交易量。",
        referral_qualified_for_reward: "- 您推荐的人是否符合奖励要求。",
        referral_ib_programs: "在从 10 位推荐人处赚取奖励后，您可以成为 IB 或继续在 Refer-and-Earn 计划下每推荐一位，您和您推荐的人都将收到 20 美元奖励。您可以对我们的推荐和 IB 计划的优点和特色进行比较。"
    },
    calculators_common: {
        asset_class: "资产类别",
        forex: "外汇",
        commodities: "商品",
        indices: "指数",
        account_base_currency: "账户基础货币",
        usd: "美元",
        gbp: "英镑",
        aud: "澳元",
        eur: "欧元",
        symbol: "符号",
        select_symbol: "选择符号",
        trade_size_in_lots: "交易规模（手数）",
        calculate: "计算"
    },
    margin: {
        margin_required: "所需保证金：",
        maximum_leverage: "最大杠杆:"
    },
    pip: {
        pip_value: "Pip 价值:"
    },
    swap: {
        server: "服务器",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "天数",
        long_swap: "长互换：",
        short_swap: "短互换:"
    },
    //S
    dashboard:{
        select_trading_id: "选择交易 ID",
        leverage: "杠杆",
        balance: "余额",
        equity: "净值",
        free_margin: "可用保证金",
        pnl: "PNL",
        web_trader : "网页交易端",
        fund: "资金",
        promotions: "促销活动",
        hundred: "100",
        bonus: "奖金",
        avail: "可用",
        deposit_bonus: "存款奖金",
        loading_initial_data: "加载初始数据",
    },
    enable_2fa:{
        title: "谷歌身份验证（2FA）",
        description: "要启用 Google 双因素 (2FA) 身份验证，请扫描二维码并输入下面生成的一次性密码。",
        google_authenticator_code: "谷歌验证码",
        how_to_enable: "启用双因素身份验证：",
        download: "下载",
        google_authenticator_app: "谷歌身份验证器应用程序",
        on_mobile_tablet: "在您的手机/平板电脑上。",
        scan_the : "扫描",
        qr_code: "二维码",
        appearing_above: "出现在上方",
        enter_the: "输入",
        passcode: "密码",
        appers_in_google_auth_app: "出现在您的 Google 身份验证器应用程序中",
        click_on_the_button: "点击按钮",
        click_to_enable: "单击以启用",
    },
    account_security:{
        title: "谷歌身份验证（2FA）",
        description: "要启用 Google 双因素 (2FA) 身份验证，请扫描二维码并输入下面生成的一次性密码。",
        google_authenticator_code: "谷歌验证码",
        how_to_enable: "启用双因素身份验证：",
        download: "下载",
        google_authenticator_app: "谷歌身份验证器应用程序",
        on_mobile_tablet: "在您的手机/平板电脑上。",
        scan_the : "扫描",
        qr_code: "二维码",
        appearing_above: "出现在上方",
        enter_the: "输入",
        passcode: "密码",
        appers_in_google_auth_app: "出现在您的 Google 身份验证器应用程序中",
        click_on_the_button: "点击按钮",
        click_to_enable: "单击以启用",
    },
    change_pass:{
        success_message:"您的密码已成功更改.",
        ok:"确认",
        change_password: "更改密码",
        existing_password: "现有密码",
        new_password: "新密码",
        confirm_new_password: "确认新密码",
        note_one: "密码应包含最少 7 个字符、最多 10 个字符，并且应至少包含 1 个数字、1 个大写字母和 1 个特殊字符 {'(!@#$%^)'}。",
        note_two: "请注意，个人资料密码与您的交易账户密码不同",
        cancel: "取消",
    },
    corporate_varify_step_three:{
        please_upload_file: "请上传文件",
        out_of_documents: "共 8 个文档",
        add_file: "添加文件",
        max_file_size: "上传文件最大为"
    },
    corporate_varify:{
        corporation_info: '企业信息',
        account_creation: "创建账户",
        verification: "验证",
        deposit: "存款",
        select_platform: "选择平台",
        select_account_type: "选择账户类型",
        select_leverage: "选择杠杆",
        select_base_currency: "选择账户基础货币",
        select_currency: "选择货币",
        password: "密码",
        pass_length_alert: "密码最小长度为 5 个字符，且必须至少包含 1 个小写字母、1 个大写字母、1 个数字和 1 个特殊字符。",
        of_characters: "字符数",
        lowercase_letter: '小写字母',
        capital_letter : "大写字母",
        number: "数字",
        special_character : "特殊字符",
        confirm_password: "确认密码",
        create_account : "创建帐户",
    },
    corporation_info:{
        name_of_company: "公司名称",
        country_of_company: "公司所在国家",
        select_company_country: "选择公司国家",
        registration: "注册",
        submit: "提交",
    },
    profile:{
        personal_details: "个人资料",
        uploaded_documents: "上传的文件",
        no_documents_yet: "还没有文件",
    },
    questions:{
        financial_details: "财务详情",
        sub_heading_one: "预计年收入总额",
        select_annual_income: "选择年收入",
        sub_heading_two: "预计净资产总额",
        sub_heading_two_desc: "个人或公司的总资产减去总负债。",
        select_net_worth:"选择净资产",
        sub_heading_three: "职业行业",
        select_occupation: "选择职业",
        sub_heading_four: "输入其他职业",
        sub_heading_five: "资金来源",
        sub_heading_six: "输入其他资金来源",
        sub_heading_seven: "美国 FATCA 报告对象",
        sub_heading_eight: "税务居住国/司法管辖区",
        select_residence_country: "选择居住国家",
        sub_heading_nine: "您有纳税人识别号码吗？",
        sub_heading_ten: "输入纳税人识别号码",
        sub_heading_eleven: "如果没有纳税人识别号码，请输入原因",
        select_reasons: "选择原因",
        enter_reason: "输入原因",
        submit: "提交",
        dear: "亲爱的",
        message_one: "根据您提供的信息，您似乎是美国税务居民。",
        message_two: "请注意，由于我们的监管合规性，AAAFx 无法接受美国税务居民的客户。",
        message_three: "我们十分感谢您的理解。",
        message_four: "诚挚问候，",
        message_five: "AAAFx",
        close: "关闭",
    },
    verify:{
        account_creation: "创建账户",
        financial_details: "财务详情",
        verification: "验证",
        deposit: "存款",
        select_platform: "选择平台",
        select_account_type: "选择账户类型",
        select_leverage: "选择杠杆",
        select_base_currency: "选择账户基础货币",
        select_currency: "选择货币",
        password: "密码",
        pass_message_one: "密码最小长度为 5 个字符，且必须至少包含 1 个小写字母、1 个大写字母、1 个数字和 1 个特殊字符。",
        pass_message_two: "密码最小长度为 8 个字符，且必须至少包含 1 个小写字母、1 个大写字母、1 个数字和 1 个特殊字符。",
        of_characters: "字符数",
        lowercase_letter: "小写字母",
        capital_letter: "大写字母",
        number: "数字",
        special_character: "特殊字符",
        confirm_password: "确认密码",
        create_account: "创建账户",
        doc_message_one: "您提交的文件已被自动验证流程拒绝。已创建与此相关的票证，您可以在其中重新上传您的文件，以便我们手动验证文件（如果您愿意）。",
        view_ticket: "查看票证",
    },
    verify_quest_bkp:{
        account_creation: "创建账户",
        questionnaire: "调查问卷",
        verification: "验证",
        deposit:"Deposit",
        select_platform: "选择平台",
        select_account_type: "选择账户类型",
        select_leverage: "选择杠杆",
        select_base_currency: "选择账户基础货币",
        select_currency: "选择货币",
        password: "密码",
        pass_length_alert: "密码最小长度为 5 个字符，且必须至少包含 1 个小写字母、1 个大写字母、1 个数字和 1 个特殊字符。",
        of_characters: "字符数",
        lowercase_letter: "小写字母",
        capital_letter: "大写字母",
        number: "数字",
        special_character: "特殊字符",
        confirm_password: "确认密码",
        create_account: "创建账户",
        doc_message_one: "您提交的文件已被自动验证流程拒绝。已创建与此相关的工单，您可以在其中重新上传您的文件，以便我们手动验证文件（如果您愿意）。",
        view_ticket: "查看工单",
    },
    close_ticket:{
        heading: "关单",
        create_request: "创建请求",
        open_tickets: "开单",
        ticket_number: "单号",
        trading_id: "交易 ID",
        status: "状态",
        subject: "主题",
        created: "已创建",
        closed: "已关闭",
        action: "操作",
        view_ticket: "查看工单",
        no_tickets_found: "没有找到工单",
    },
    open_ticket:{
        heading: "开单",
        create_request: "创建请求",
        open_tickets: "开单",
        closed_ticket: "关单",
        ticket_number: "单号",
        trading_id: "交易 ID",
        status: "状态",
        subject: "主题",
        created: "已创建",
        action: "操作",
        view_ticket: "查看工单",
        no_tickets_found: "没有找到工单",
    },
    request_call:{
        success_message:"您请求回电已被收到。我们的工作人员将很快联系您。",
        ok: "确认",
        request_call_back:"请求回电",
        first_name: "名",
        last_name: "姓",
        email_id: "电子邮件 ID",
        phone_number: "电话号码",
        timezone: "时区",
        date: "日期",
        preferred_time: "首选时间",
        department: "部门",
        select_department: "选择部门",
        new_accounts: "新帐户",
        deposits: "存款",
        withdrawals: "提款",
        partnership: "合伙",
        technical_support: "技术支持",
        message: "信息",
        send_request: "发送请求",
    },
    support_page:{
        success_message:"已为你成功创建支持票。您可以在 “开放票证” 中查看。 ",
        ok:"确认",
        support: "支持",
        create_req:"创建请求",
        open_tickets:"开单",
        closed_tickets: "关单",
        otp_msg:"我们已将一次性密码发送到您的注册电子邮件。请输入它以验证支持票证请求。",
        otp: "一次性密码",
        submit: "提交",
        reason: "原因",
        select_a_reason: "选择一个原因",
        trading_id: "交易 ID",
        select_trading_account: "选择交易帐户",
        subject: "主题",
        trade_order_id: "交易订单 ID",
        time_of_trade_opening: "开市时间",
        time_of_trade_closing: "闭市时间",
        instrument_traded: "交易工具",
        type_of_trade: "交易类型",
        select_trade_type: "选择交易类型",
        details_of_the_issue: "问题详情",
        refund_claim_amount: "退款索赔金额",
        message: "信息",
        note: "备注",
        file_attachments: "文件附件",
        file_size_msg: "文档大小不应超过 1MB",
        file_format_msg: "仅限文件格式（jpeg 或 pdf）",
        lowercase_note: "备注",
        note_desc: "如果在进行任何帐户操作时出现任何错误，请在创建工单时附上屏幕截图",
        create_support_request: "创建支持请求",
    },
    become_ib:{
        heading: "介绍经纪人（IB）",
        description: "通过我们的 IB 计划增加您的收入。 <br /> 获取您的专属链接，将其与您的朋友分享，并在他们进行交易时赚取佣金。",
        sub_heading: "我们提供两类 IB 计划：",
        point_one: "标准 IB 计划 - 直接从您的客户那里获得 20% 的佣金收入。这对于想要从头开始或可以开始为我们带来有限数量客户的新手 IB 非常有用。",
        point_two: "高级 IB 计划 - 这是为我们较大的 IB 提供的高回报和定制 IB 计划。这对于拥有大量客户群、可以带来更大交易量的人来说非常有用。",
        note_one: "一旦您建立起足够大的网络，您就可以从标准 IB 计划进阶到高级 IB 计划。",
        earn_with: "赚取",
        zero_investment_or: "零投资或",
        experience: "经验",
        weekly_ib: "每周 IB",
        commissions: "佣金",
        payouts: "支出",
        unlimited: "无限",
        earnings: "收益",
        potential: "潜力",
        sub_cont_point_four: "高度定制且回报丰厚的高级 IB 计划",
        ultra_fast: "超快",
        withdrawals_of_ib: "IB 提款",
        commission: "佣金",
        easy_user: "简单的用户",
        interface_of: "界面",
        ib_portal: "IB 门户网站",
        dedicated: "专用的",
        account: "帐户",
        manager: "经理",
        helpful_and: "有帮助的和",
        free_marketing: "免费营销",
        material: "材料",
        become_an_ib: "成为一名介绍经纪人",
    },
    pamm_acct:{
        title:"PAMM 账户",
        description_one: "PAMM（百分比分配管理模块）是一个管理帐户，经理在其所有子帐户中执行交易。经理和投资者可以自由选择绩效费结构，我们将负责将其落实到位。",
        description_two: "AAAFx 提供高度灵活和定制的 PAMM 交易解决方案。",
        sub_title: "如何注册成为 PAMM 经理",
        sub_Point_one: "一旦您有至少四位投资者且总存款达到 5,000 美元或以上，您的 PAMM 经理帐户即可开设。",
        sub_Point_two: "只需注册为 IB，即可成为我们的 PAMM 经理。让您的客户使用您的 IB 链接注册，满足上述第一个条件。",
        sub_Point_three: "通过实时聊天联系我们或发送电子邮件至",
        sub_Point_four: "开始在 PAMM 绩效费之外赚取 IB 佣金。",
        minimul_investment: "最少的投资",
        ease_of_access: "易于访问",
        ultimate_trading_conditions: "最终交易条件",
        trade_security: "交易安全",
        request_pamm: "请求 PAMM",
    },
    add_payment_methods:{
        success_message: "您的付款方式已成功添加。您可以在“开放票证”下跟踪它。",
        ok: "确认",
        otp_message: "我们已将一次性密码发送到您的注册电子邮件。请输入它以验证支持票证请求。",
        otp: "一次性密码",
        submit: "提交",
        page_heading: "添加付款方式",
        select_payment_method: "选择付款方式",
        select_method: "选择方式",
        bank: "银行",
        credit_card: "信用卡",
        crypto: "加密货币",
        select_crypto_currency: "选择加密货币",
        select_crypto: "选择加密币",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "添加您的银行详细信息",
        bank_name: "银行名称",
        account_name: "帐户名称",
        account_number: "帐号",
        country: "国家",
        select_country: "选择国家",
        iban: "IBAN",
        iban_note: "我的银行不签发 IBAN",
        swift: "Swift",
        bic: "BIC",
        sort_code: "排序代码",
        bank_address: "银行地址",
        upload_your_bank_statement: "上传您的银行对账单",
        upload_doc_info_one: "文档大小不应超过 1MB",
        upload_doc_info_two: "仅限文件格式（jpeg 或 pdf）",
        note: "备注",
        note_msg: "如果在进行任何帐户操作时出现任何错误，请在创建工单时附上屏幕截图",
        create_support_request: '创建支持请求',
        add_your_card_details: "添加您的银行卡详细信息",
        creadit_card_number: "信用卡号码",
        month: "月",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "年",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "我们需要以下信息来进行卡验证",
        varification_msg_one: "卡正面的彩色复印件，显示：全名、到期日期、银行名称/徽标、信用卡号的前 4 位和后 4 位数字，隐藏中间 8 位数字。",
        upload_supporting_document: "上传证明文件",
        varification_msg_two: "卡背面的彩色复印件，隐藏 CVV 安全码。背面复印件应显示持卡人的签名",
        add_selected_crypto_address: "添加选定的加密地址",
        address: "地址",
    },
    deposit:{
        account_type: "帐户类型",
        select_type: "选择类型",
        live: "实时",
        trading_account: "交易帐户",
        select_trading_account: "选择交易帐户",
        balance: "余额",
        fund: "资金",
        amount: "金额",
        region: "地区",
        currencies: "货币",
        processing_time: "处理时间",
        action: "操作",
        view_more: "查看更多",
        currency: "货币",
        zar: "ZAR",
        swift_code: "SWIFT 代码",
        beneficiarys_name: "收款人名称",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "帐号",
        user_account_number: "62928423269",
        bank_address: "银行地址",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "银行名称",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "欧元",
        city: "城市",
        city_info: "伦敦",
        country: "国家",
        country_info: "英国",
        dixipay_note: "Dixipay 仅接受存款。以欧元计",
        you_can_deposit: "您可以存款",
        you_can_deposit_msg: "在以下地址中，转换后将添加所选帐户货币的等值金额",
        copy: "复制",
        done: "完毕",
        network_msg: "支持ERC-20网络（USDT、USDC、ETH），使用任何其他网络将无法达到我们的目的。",
    },
    fund_index: {
        add_funds: "增加资金",
        cancel: "取消",
        ok: "确认",
        your_request_to_add: "您的添加请求",
        to_your_demo_account_number: "到您的模拟帐号",
        has_been_successfully_completed: "已成功完成",
        your_request_to_withdraw: "您从交易 ID的",
        from_the_trading_id: "提款请求",
        has_been_received: "已经收到",
        click_to_proceed_withdrawal: "请点击发送到您注册电子邮件地址的确认链接来处理提款",
        has_been_successfully: "已成功",
        your_request_to_add_usd: "您添加美元的请求",
    },
    request_verify: {
        verifying_your_request: "验证您的请求",
        success: "成功",
        go_to_transactions: "前往交易",
        error: "错误",
    },
    transactions: {
        list_of_transactions: "交易清单",
        deposits: "存款",
        withdrawals: "提款",
        bonus: "奖金",
        deposit_transactions: "存款交易",
        filter_by: "过滤",
        select_trading_id: "选择交易 ID",
        all: "所有",
        date: "日期",
        account_id: '账户 ID',
        currency: "货币",
        payment_mode: "付款方式",
        deposit_amount: "存款金额",
        status: 'Status',
        no_deposits_yet: "还没有存款",
        withdrawal_mode: "提款方式",
        withdrawal_amount: "提款金额",
        action: "操作",
        view_more : "查看更多",
        no_withdrawals_yet: "尚未提款",
        bonus_amount: "奖金金额",
        pending : "待办",
        no_bonus_transactions_yet: "尚未奖金交易",
        deposit_currency: "存款货币",
        account_currency: '账户货币',
        address: '地址',
    },
    withdrawal: {
        kyc_req_msg: "在请求提款之前必须完成 KYC。请使用支持票提交地址证明",
        Click_here: "点击此处",
        or_email_to: '或发送电子邮件至',
        with_step_heading: "接受以下地址证明",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "水电费账单",
        with_step_two: "银行对帐单",
        with_step_three: "政府签发的税务文件",
        note: "备注",
        note_info: "地址证明必须不超过 4 个月",
        ok: "确认",
        enable_2fa_msg: "必须启用 2FA 才能提出提款请求。请点击以下按钮",
        click_to_enable: "单击以启用",
        select_trading_id: "选择交易 ID",
        account_id: "帐户 ID",
        account_type: "帐户类型",
        platform: '平台',
        leverage: "杠杆",
        currency: "货币",
        free_margin: "可用保证金",
        note_info_two: "以您交易账户的基础货币输入提款金额。",
        amount: "金额",
        mode_of_payment: "付款方式",
        create_transaction: "创建交易",
        cancel: "取消",
        add_payment_method: "添加付款方式",
        no_amount_available: "此帐户中没有可用金额",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "选择帐户",
    },
    footer: {
        legal_information: "法律信息",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. 经南非金融部门行为监管局授权并受其监管（FSCA 号 2017/315029/07）。",
        risk_warning: "风险提示",
        risk_warning_info: "交易现货货币涉及巨大风险，并且始终存在潜在的损失。您的交易结果可能会有所不同。由于外汇市场交易的风险系数较高，因此只能使用真正的“风险”资金进行此类交易。如果您没有可承受损失的额外资本，则不应在外汇市场进行交易。从来不存在“安全”的交易系统，也没有人能够保证利润或免受损失。",
    },
    header: {
        welcome: "欢迎", 
        profile: '个人资料',
        request_callback: "请求回电",
        support_ticket: "支持票",
        change_password: "更改密码",
        logout: "登出",
    },
    pagination: {
        total_records: "总记录数", 
    },
    side_bar: {
        dashboard: "仪表板",
        manage_accounts: "管理帐户",
        fund: "资金",
        bonus: "奖金",
        become_a_partner: "成为一个合伙人",
        tools: "工具",
        bonus_and_promotions: '奖金和促销活动',
    },
    success_box: {
        otp_varify: "请输入 Google 身份验证器应用中显示的 6 位数一次性 PIN 码。",
        cancel: "取消",
        submit: "递交",
        trouble_with_2fa: "您的双因素验证码有问题吗？",
        click_varify_with_email: "单击此处通过电子邮件验证",
        or: "或",
        click_here: "点击此处",
        to_enable_2fa: "启用您的 2FA 并完成您的请求",
        take_me_back: "带我返回",
    },
    tost_message: {
        varify_acc: "请验证您的帐户以创建真实帐户",
        click_to_begin: "单击开始验证过程",
    },
    proof_residence_alert: {
        you_have: "您",
        days_left_for_proof: "距离提交居住证明还有几天。",
        click_here: "点击此处",
        to_upload: "上传",
    },
    closed_trades: {
        login: "登录",
        order: "订单",
        symbol: "符号",
        volume: "交易量",
        open_price: "开盘价",
        open_time: "开盘时间",
        commission: "佣金",
        type: 'Type',
        sl: "止损",
        tp: "止盈",
        close_price: '收盘价',
        close_time: '收盘时间',
        swap: '互换',
        pnl: "PNL",
        comment: '评论',
        no_record_found: "没有找到记录",
    },
    open_trade: {
        order: '订单',
        symbol: '符号',
        type: '类型',
        volume: "交易量",
        open_price: "开盘价",
        pnl: "PNL",
        no_record_found: "没有找到记录",
    },
}